document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
});

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  var option = event.target.options[event.target.selectedIndex];
  var form = event.target.closest('form');
  if (!form) return;
  var button = form.querySelector('[data-add-to-cart]');
  var info = form.closest('[data-product-info]');
  var price = info ? info.querySelector('[data-product-price]') : null;
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    var available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Add to cart' : 'Sold out';
  }
});
